<template>
  <div class="merit">
    <div v-if="$props.merit.description" class="text-justify">
      <p>
        <font-awesome-icon :icon="['fas', 'scroll']" />
        <span class="merit-text" v-html="$props.merit.description"></span>
      </p>
    </div>
    <div v-if="$props.merit.youtubeEmbed" class="merit-youtube">
      <iframe
        :src="$props.merit.youtubeEmbed"
        class="merit-youtube-iframe"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Merit",
  props: {
    /*
     * @property - merit
     * Defines all content inside this component
     * $merit.description
     * $merit.youtubeEmbed
     */
    merit: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.merit {
  border-top: 0.0625rem solid $main-green;
  padding: 1.5rem 0 3rem 0;

  &-text {
    padding-left: 0.75rem;
  }

  &-youtube {
    height: 0;
    margin: auto;
    padding-bottom: 56.25%;
    position: relative;

    @include breakpoint($large) {
      max-width: 50rem;
      padding-bottom: 28.125rem;
    }

    &-iframe {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}
</style>
